import type { MetricsTranslations } from "../interfaces/metrics";

export const metricsTranslations: MetricsTranslations = {
  page_title: "Métricas",
  page_description:
    "El dinero que mueven las billeteras, OTC y los experimentos, en todas las organizaciones.",
  tab_otc: "OTC",
  tab_experiments: "Experimentos",
  refresh: "Actualizar",
  period_label: "Periodo",
  period_option: "{{days}} días",
  window_caption: "Del {{from}} al {{to}}, comparado con los {{days}} días anteriores.",
  error_title: "No pudimos cargar las métricas",
  error_text: "Vuelve a intentarlo en un momento.",
  error_retry: "Reintentar",
  kpi_volume: "Volumen",
  kpi_ticket: "Ticket promedio",
  change_vs_previous: "{{change}} vs {{days}} días anteriores",
  change_none: "Sin datos del periodo anterior",
  top_hint: "Por volumen en el periodo.",
  col_user: "Usuario",
  col_organization: "Organización",
  col_transactions: "Transacciones",
  col_volume: "Volumen",
  col_ticket: "Ticket promedio",
  via_api: "Vía API",
  top_empty: "Nadie operó en este periodo.",
  experiments_description: "Pruebas A/B: cada usuario ve siempre la misma versión mientras la prueba corre.",
  experiments_empty: "Todavía no hay experimentos.",
  col_experiment: "Experimento",
  col_status: "Estado",
  col_split: "Reparto",
  col_users: "Usuarios",
  col_started: "Inicio",
  status_RUNNING: "En curso",
  status_PAUSED: "Pausado",
  status_ROLLED_OUT: "Encendido para todos",
  experiment_otc_volume_discount: "Banner de descuento por volumen (compra y venta de USDT)",
  variant_otc_volume_discount_control: "Sin banner",
  variant_otc_volume_discount_treatment: "Con banner",
  variant_users: "{{variant}}: {{users}}",
  detail_back: "Experimentos",
  detail_since: "Desde el {{date}}",
  detail_until: "Hasta el {{date}}",
  detail_not_found: "No encontramos ese experimento.",
  detail_no_metric: "Este experimento todavía no tiene métricas.",
  detail_how_to_read:
    "La conversión es la parte de los usuarios que compró al menos una vez desde que entró a la prueba. Con menos de 30 usuarios por grupo, toma la diferencia como una tendencia.",
  group_users: "Usuarios",
  group_conversion_rate: "Conversión",
  group_average: "Valor promedio",
  significance_significant: "Diferencia significativa",
  significance_trend: "Aún no es concluyente",
  significance_not_enough: "Faltan datos",
  action_pause: "Pausar",
  action_resume: "Reanudar",
  action_rollout: "Encender para todos",
  confirm_pause_title: "¿Pausar el experimento?",
  confirm_pause_text:
    "Todos verán la versión de control. Las asignaciones se conservan y el análisis se detiene aquí.",
  confirm_resume_title: "¿Reanudar el experimento?",
  confirm_resume_text: "Cada usuario vuelve a su grupo y los nuevos se asignan al azar.",
  confirm_rollout_title: "¿Encender para todos?",
  confirm_rollout_text:
    "Todos verán la versión «{{variant}}», también quienes estaban en el otro grupo. El análisis se cierra aquí.",
  confirm_cancel: "Cancelar",
  toast_updated: "Experimento actualizado",
  toast_failed: "No pudimos actualizar el experimento",
  action_split: "Cambiar reparto",
  detail_split: "Reparto: {{split}}",
  split_title: "Cambiar reparto",
  split_description: "Qué parte de los usuarios nuevos ve cada versión.",
  split_presets_label: "Usuarios nuevos en «{{variant}}»",
  split_input_label: "{{variant}} (%)",
  split_invalid_number: "Escribe un número entero entre 0 y 100.",
  split_total: "Total: {{total}} %",
  split_total_error: "Suma {{total}} %; tiene que sumar 100 %.",
  split_keep_note:
    "Quien ya tiene una versión la conserva. El nuevo reparto aplica a quien llegue desde ahora.",
  split_save: "Guardar reparto",
  toast_split_updated: "Reparto actualizado",
  toast_split_failed: "No pudimos cambiar el reparto",
  user_section_title: "Versión por usuario",
  user_section_hint:
    "Busca a alguien por nombre o correo para ver qué versión tiene, aunque todavía no haya cotizado, y cambiarla. Una versión fija se ve siempre, aunque el experimento esté pausado, y no cuenta en los resultados.",
  user_not_found: "No encontramos un usuario con ese correo.",
  user_lookup_failed: "No pudimos consultar ese usuario.",
  user_sees: "Ve: {{variant}}",
  source_forced: "Versión fijada por staff.",
  source_assigned: "Le tocó al azar el {{date}}.",
  source_not_assigned: "Todavía no ha cotizado: esta es la versión que le tocará.",
  source_staff: "Es staff: ve la versión que se está probando.",
  source_paused: "El experimento está pausado: ve la versión de control.",
  source_rolled_out: "El experimento está encendido para todos.",
  user_force: "Fijar en «{{variant}}»",
  force_otc_volume_discount_treatment: "Activar banner",
  force_otc_volume_discount_control: "Quitar banner",
  user_release: "Volver al sorteo",
  user_release_hint: "Al volver al sorteo verá «{{variant}}».",
  toast_forced: "{{email}} ahora ve «{{variant}}»",
  toast_released: "{{email}} volvió al sorteo",
  toast_override_failed: "No pudimos cambiar la versión",
  overrides_title: "Usuarios con versión fija",
  overrides_since: "Desde el {{date}}",
  group_average_otc_trade: "Ticket promedio",
  overview_volume: "Volumen total",
  overview_operations: "Operaciones",
  overview_users: "Usuarios activos",
  daily_title_volume: "Volumen por día",
  daily_title_operations: "Operaciones por día",
  daily_hint: "Cada día, las compras (de USDT y recargas de tarjeta, una sobre otra) junto a las ventas.",
  daily_measure_label: "Medida",
  side_buy_short: "Compras",
  side_sell_short: "Ventas",
  side_card_top_up_short: "Tarjetas",
  measure_volume: "Volumen",
  measure_operations: "Operaciones",
  sides_title: "Compras, tarjetas y ventas",
  sides_hint: "Cada lado frente a sus {{days}} días anteriores.",
  col_metric: "Métrica",
  top_title: "Quiénes más operan",
  top_tab_buy: "Compran más",
  top_tab_sell: "Venden más",
  top_tab_card_top_up: "Recargan tarjetas",
  verdict_title: "Resultado hasta hoy",
  verdict_headline_up: "«{{variant}}» convierte {{change}} más que «{{against}}»",
  verdict_headline_down: "«{{variant}}» convierte {{change}} menos que «{{against}}»",
  verdict_headline_equal: "«{{variant}}» y «{{against}}» convierten igual",
  verdict_rates:
    "Operó el {{variantRate}} de los usuarios «{{variant}}», frente al {{againstRate}} de «{{against}}».",
  verdict_significant: "La diferencia es significativa (p = {{p}}): es difícil que sea azar.",
  verdict_trend: "Todavía puede ser azar (p = {{p}}). Deja correr la prueba.",
  verdict_not_enough:
    "Faltan datos: cada grupo necesita al menos 30 usuarios. Toma la diferencia como una tendencia.",
  verdict_empty: "Todavía nadie ha operado en la prueba.",
  col_difference: "Diferencia",
  currency_label: "Moneda",
  currency_info_label: "Qué es USD aquí",
  currency_info:
    "En USD ves los USDT comprados y vendidos (1 USDT ≈ 1 USD). El precio por USD siempre va en pesos.",
  info_label: "Qué incluye: {{metric}}",
  sides_split: "Compras {{buy}} · Tarjetas {{cards}} · Ventas {{sell}}",
  info_volume:
    "Compras, recargas de tarjeta y ventas completadas en el periodo. Una compra o una recarga de tarjeta suma los pesos que pagó el cliente, con comisión; una venta, los pesos que pagamos a su llave, antes de nuestra comisión. En USD, los USDT entregados y recibidos.",
  overview_net_flow: "Flujo neto",
  info_net_flow:
    "Compras y recargas de tarjeta menos ventas, en la moneda elegida. Positivo: los clientes se llevaron más USDT de los que trajeron. Negativo: trajeron más de los que se llevaron.",
  net_flow_buy: "Compraron más de lo que vendieron",
  net_flow_sell: "Vendieron más de lo que compraron",
  net_flow_even: "Compraron lo mismo que vendieron",
  info_operations:
    "Compras pagadas (USDT entregados), recargas de tarjeta entregadas (USDT enviados a la tarjeta) y ventas completadas (pesos acreditados) en el periodo. Las que fallaron o vencieron no cuentan aquí: están en «No completadas».",
  overview_users_new: "Nuevos: {{users}}",
  info_users:
    "Quienes completaron al menos una compra, recarga de tarjeta o venta en el periodo; una operación por API cuenta como su organización. Nuevo: su primera operación de siempre cayó en este periodo.",
  daily_difference: "Compras − ventas: {{value}}",
  daily_purchases_total: "Compras",
  daily_segment_usdt: "Compra de USDT",
  daily_segment_cards: "Recarga de tarjeta",
  daily_cards_share: "Recargas de tarjeta: {{share}} de las compras del periodo.",
  side_label: "Lado",
  prices_title: "Precio por USD",
  prices_hint: "Lo que el cliente pagó o recibió por cada USDT, con comisiones, ponderado por volumen.",
  prices_buy: "Compraron a",
  prices_sell: "Vendieron a",
  prices_card_top_up: "Recargaron tarjetas a",
  prices_spread: "Diferencia",
  prices_spread_meta: "{{percent}} sobre el precio de venta",
  info_spread:
    "Precio de compra menos precio de venta: lo que separa a quien compra de quien vende, con nuestras comisiones y el margen de liquidez incluidos.",
  prices_empty: "Sin compras ni ventas en este periodo: no hay precio que mostrar.",
  info_price:
    "Pesos por cada USDT, con comisiones, ponderado por volumen. Compra: pesos debitados ÷ USDT recibidos. Recarga de tarjeta: pesos debitados ÷ USDT enviados a la tarjeta, antes de la comisión de depósito de la tarjeta. Venta: pesos acreditados ÷ USDT vendidos.",
  info_volume_side:
    "Compra y recarga de tarjeta: los pesos que pagó el cliente, con comisión (en USD, los USDT entregados). Venta: los pesos que pagamos a su llave, antes de nuestra comisión (en USD, los USDT recibidos).",
  info_ticket: "Volumen dividido entre operaciones, en la moneda elegida.",
  row_duration: "Tiempo real",
  duration_p90: "9 de cada 10 en menos de {{time}}",
  info_duration:
    "Mediana del periodo. Compra: desde que se crea hasta que se entregan los USDT. Recarga de tarjeta: desde que se crea hasta que los USDT llegan a la dirección de la tarjeta, sin lo que tarda la tarjeta en acreditarlos. Venta: desde que llega el depósito hasta que pagamos los pesos; puede sumar hasta un minuto por la frecuencia con que la revisamos.",
  row_estimate: "Tiempo que ve el cliente",
  estimate_network: "{{network}}: {{time}}",
  estimate_none: "Sin estimado",
  info_estimate:
    "Lo que la pantalla de compra o venta le muestra hoy al cliente, por red. Sale de las operaciones recientes, no de este periodo. Las recargas de tarjeta muestran su propia espera, en la tarjeta.",
  row_not_completed: "No completadas",
  not_completed_rate: "{{rate}} de las que terminaron",
  info_not_completed:
    "Compras y recargas de tarjeta fallidas, canceladas o revertidas, y ventas vencidas sin depósito o devueltas, que terminaron en el periodo. El porcentaje es sobre todas las que terminaron, completadas o no.",
  reason_count: "{{reason}}: {{total}}",
  reason_failed: "Fallida",
  reason_cancelled: "Cancelada",
  reason_reversed: "Revertida",
  reason_expired: "Vencida sin depósito",
  reason_refunding: "Devolviendo",
  reason_refunded: "Devuelta",
  users_split: "Nuevos: {{new}} · Recurrentes: {{returning}}",
  info_users_side:
    "Quienes completaron al menos una operación de ese lado; por API cuenta la organización. Nuevo: su primera operación de ese lado cayó en este periodo.",
  conversion_split: "{{converted}} de {{quoted}} que cotizaron",
  info_conversion:
    "Por usuario, no por cotización: quien cotizó diez veces y compró una vez convirtió. Cuentan los usuarios de las organizaciones; el staff no, porque sus cotizaciones suelen ser pruebas. Las recargas de tarjeta no se cotizan en la mesa, así que no tienen conversión.",
  intent_title: "Quién cotizó y qué operó",
  intent_hint: "La cotización más grande de cada usuario frente a lo que terminó operando en el periodo.",
  intent_quoted: "Cotizaron",
  intent_converted: "Operaron",
  intent_captured: "Capturado",
  intent_captured_meta: "{{traded}} de {{quoted}} cotizados",
  info_captured:
    "Lo que operaron quienes cotizaron, frente a la suma de la cotización más grande de cada uno. Pasa de 100 % si operaron más de lo que cotizaron.",
  intent_list_hint: "Los 10 con la cotización más grande.",
  col_quotes: "Cotizaciones",
  col_max_quote: "Cotización más grande",
  col_traded: "Operado",
  quoter_traded: "Operó",
  quoter_not_traded: "No operó",
  quoter_last: "Última cotización: {{date}}",
  intent_empty: "Nadie cotizó en este periodo.",
  user_search_label: "Usuario",
  user_search_placeholder: "Nombre o correo",
  user_search_hint: "Escribe al menos 3 letras.",
  user_search_searching: "Buscando…",
  user_search_empty: "Nadie coincide con esa búsqueda.",
  user_search_failed: "No pudimos buscar. Vuelve a intentarlo.",
  user_would_see: "Le tocaría: {{variant}}",
  summary_title: "Resumen por versión",
  col_variant: "Versión",
  summary_baseline: "Referencia",
  tab_tpv: "TPV",
  reason_rejected: "Rechazada",
  tpv_overview_tpv: "TPV",
  tpv_info_tpv:
    "Cobros confirmados más dispersiones pagadas, en dólares a la tasa del día de cada operación. Los swaps y las recargas de Coloca no suman.",
  tpv_split: "Entra {{in}} · sale {{out}}",
  tpv_overview_revenue: "Ingresos de Coloca",
  tpv_info_revenue:
    "La comisión de Coloca en cobros y dispersiones, la comisión de conversión (dispersiones entre monedas y swaps) y el resultado de ejecución de la mesa en las compras de USDT, que finanzas aún no valida. No resta costos de proveedor ni impuestos que asume Coloca.",
  tpv_take_rate_value: "Take rate {{rate}}",
  tpv_ticket_value: "Ticket promedio {{ticket}}",
  tpv_overview_organizations: "Organizaciones activas",
  tpv_info_organizations:
    "Organizaciones con al menos un cobro o una dispersión en el periodo. Nuevas: su primera operación de la historia cae en el periodo.",
  tpv_organizations_new: "{{organizations}} nuevas",
  tpv_flow_title: "Por dónde entra y sale el dinero",
  tpv_flow_hint:
    "El TPV del periodo por producto: a la izquierda lo que entra a las billeteras, a la derecha lo que sale.",
  tpv_flow_in: "Entra",
  tpv_flow_out: "Sale",
  tpv_flow_net_in: "Entró {{amount}} más de lo que salió",
  tpv_flow_net_out: "Salió {{amount}} más de lo que entró",
  tpv_flow_net_even: "Entró lo mismo que salió",
  tpv_flow_empty: "No hubo cobros ni dispersiones en este periodo.",
  tpv_flow_aria: "Entraron {{in}} y salieron {{out}}",
  tpv_flow_share: "{{share}} de lo que se movió",
  tpv_product_collection: "Cobros",
  tpv_product_otc_sell: "Venta de USDT",
  tpv_product_payout: "Dispersiones",
  tpv_product_otc_buy: "Compra de USDT",
  tpv_product_card_top_up: "Recarga de tarjetas",
  tpv_daily_title_volume: "TPV por día",
  tpv_daily_title_operations: "Operaciones por día",
  tpv_daily_hint: "Cobros y dispersiones de cada día, en dólares a la tasa de ese día.",
  tpv_series_in: "Cobros",
  tpv_series_out: "Dispersiones",
  tpv_daily_net: "Neto: {{value}}",
  tpv_flows_title: "Flujos",
  tpv_flows_hint:
    "Cobros y dispersiones forman el TPV; swaps y recargas de Coloca van aparte. Cada cifra frente a los {{days}} días anteriores.",
  tpv_flow_payins: "Cobros",
  tpv_flow_payouts: "Dispersiones",
  tpv_flow_fx: "Swaps",
  tpv_flow_top_ups: "Recargas Coloca",
  tpv_row_operations: "Operaciones",
  tpv_info_operations:
    "Cobros confirmados, dispersiones pagadas, swaps y recargas, por la fecha en que se completaron.",
  tpv_row_volume: "Volumen",
  tpv_info_volume:
    "En dólares a la tasa del día de cada operación: lo que envió el pagador en un cobro, lo que salió de la billetera en una dispersión o un swap, comisión de conversión incluida.",
  tpv_row_ticket: "Ticket promedio",
  tpv_info_ticket: "Volumen entre operaciones convertidas a dólares.",
  tpv_row_revenue: "Ingresos",
  tpv_revenue_service: "Comisión {{amount}}",
  tpv_revenue_conversion: "Conversión {{amount}}",
  tpv_revenue_fx_execution: "Ejecución OTC {{amount}}",
  tpv_row_take_rate: "Take rate",
  tpv_info_take_rate:
    "Ingresos sobre volumen. En el total, todos los ingresos (también los de swaps) sobre el TPV.",
  tpv_row_organizations: "Organizaciones",
  tpv_row_not_completed: "No completadas",
  tpv_info_not_completed:
    "Cobros rechazados, fallidos o revertidos y dispersiones fallidas, canceladas o revertidas, por cuándo terminaron. Los cobros que nadie pagó y vencieron van aparte.",
  tpv_row_expired: "Cobros vencidos",
  tpv_info_expired:
    "QR o CLABE que nadie pagó y que el sistema cerró al vencer. No es un fallo: es un cobro que no se usó.",
  tpv_row_in_flight: "En curso ahora",
  tpv_info_in_flight:
    "Cobros detectados sin confirmar y dispersiones creadas o en el proveedor, en este momento y a la tasa de hoy.",
  tpv_in_flight_value: "{{operations}} · {{amount}}",
  tpv_unconverted: "{{operations}} sin tasa, fuera de los dólares",
  tpv_corridors_title: "Productos y corredores",
  tpv_corridors_hint: "Cada cobro y dispersión por producto, rail, país y moneda, de mayor a menor volumen.",
  tpv_col_product: "Producto",
  tpv_col_rail: "Rail",
  tpv_col_country: "País",
  tpv_col_currency: "Moneda",
  tpv_col_operations: "Operaciones",
  tpv_col_volume: "Volumen",
  tpv_col_revenue: "Ingresos",
  tpv_col_share: "Participación",
  tpv_col_change: "Cambio",
  tpv_direction_in: "Entra",
  tpv_direction_out: "Sale",
  tpv_corridors_empty: "No hubo cobros ni dispersiones en este periodo.",
  tpv_fx_pairs_title: "Swaps por par",
  tpv_col_pair: "Par",
  tpv_custody_title: "Saldos en custodia",
  tpv_custody_hint:
    "Lo que tienen hoy las billeteras de pago, valorado a la última tasa conocida. La variación neta sale del libro contable.",
  tpv_custody_available: "Disponible",
  tpv_info_custody_available: "Saldo que las organizaciones pueden usar ya.",
  tpv_custody_pending: "Pendiente",
  tpv_info_custody_pending: "Cobros detectados que aún no se confirman.",
  tpv_custody_blocked: "Bloqueado",
  tpv_info_custody_blocked: "Reservado por dispersiones que siguen en curso; ya salió del saldo disponible.",
  tpv_custody_wallets: "Billeteras",
  tpv_info_custody_wallets:
    "Billeteras de pago de todas las organizaciones. Activas: organización y moneda con un cobro, dispersión o swap en el periodo.",
  tpv_custody_wallets_meta: "{{active}} activas · {{new}} nuevas",
  tpv_col_net_change: "Variación neta",
  tpv_info_net_change:
    "Créditos menos débitos de las billeteras en esa moneda durante el periodo, según el libro contable. Incluye reversos y ajustes, así que no cuadra con la foto de hoy.",
  tpv_custody_wallet_count: "{{wallets}} billeteras",
  tpv_custody_no_rate: "Sin tasa",
  tpv_custody_empty: "No hay billeteras de pago.",
  tpv_col_tpv: "TPV",
  tpv_col_payins: "Cobros",
  tpv_col_payouts: "Dispersiones",
  tpv_unnamed_organization: "Sin nombre",
  tpv_rates_title: "Tasas a dólares",
  tpv_rates_info:
    "Cada monto se convierte con la tasa a dólares de su propio día, tomada del histórico de tasas. USD y USDT valen 1. Un día sin tasa propia usa la del día conocido más cercano.",
  tpv_rates_filled: "{{share}} de los días con operaciones usó la tasa del día más cercano.",
  tpv_rates_exact: "Todos los días con operaciones tienen su propia tasa.",
  tpv_rates_missing: "Sin tasa, fuera de los dólares: {{currencies}}.",
  tpv_rates_latest: "Última tasa: {{date}}.",
  tpv_filter_label: "Organización",
  tpv_filter_all: "Todas las organizaciones",
  tpv_filter_all_hint: "Cada cifra suma todas las organizaciones.",
  tpv_filter_org_hint:
    "Cada cifra es solo de esta organización: flujos, corredores, saldos y la serie diaria.",
  tpv_organizations_title: "Organizaciones",
  tpv_organizations_hint:
    "Todas las que tuvieron un cobro, una dispersión o un swap en el periodo o en el anterior. Las que dejaron de operar quedan al final.",
  tpv_organizations_search: "Buscar por nombre o id",
  tpv_organizations_sort_label: "Ordenar por",
  tpv_sort_tpv: "TPV",
  tpv_sort_operations: "Operaciones",
  tpv_sort_revenue: "Ingresos",
  tpv_organizations_show_all: "Ver todas ({{organizations}})",
  tpv_organizations_show_less: "Ver solo las 10 primeras",
  tpv_organizations_empty: "Ninguna organización operó en este periodo.",
  tpv_organizations_no_match: "Ninguna organización coincide con «{{term}}».",
  tpv_col_transactions: "Transacciones",
  tpv_previous_value: "Antes {{amount}}",
  tpv_action_only_this: "Ver solo esta",
  tpv_action_only_this_aria: "Ver la página solo para {{organization}}",
  tpv_action_payins: "Cobros ({{operations}})",
  tpv_action_payouts: "Dispersiones ({{operations}})",
  tpv_action_view_transactions: "Ver transacciones",
  tpv_corridors_link_note:
    "«Ver transacciones» filtra por rail: en Bre-B también salen las ventas de USDT, y en USDT las compras y las recargas de tarjeta van juntas.",
};
